import Color, { getLuminance } from "./Color";

export const allPalettes = [
    [ '#d9d9d9', '#a6a6a6', '#8c8c8c', '#595959', '#262626' ],
    [ '#d9d9d9', '#a6a6a6', '#595959', '#262626', '#0d0d0d' ],
    [ '#a6a6a6', '#f2f2f2', '#595959', '#262626', '#0d0d0d' ],
    [ '#594F4F', '#547980', '#45ADA8', '#9DE0AD', '#E5FCC2' ],
    [ '#FFFFFF', '#CBE86B', '#F2E9E1', '#1C140D', '#CBE86B' ],
    [ '#594F4F', '#547980', '#45ADA8', '#9DE0AD', '#E5FCC2' ],
    [ '#FFFFFF', '#CBE86B', '#F2E9E1', '#1C140D', '#CBE86B' ],
    [ '#e74645', '#fb7756', '#facd60', '#fdfa66', '#1ac0c6' ],
    [ '#f9b4ab', '#fdebd3', '#264e70', '#679186', '#bbd4ce' ],
    [ '#bf7c63', '#d9a796', '#a63429', '#590a0a', '#d96262' ],
    [ '#774F38', '#E08E79', '#F1D4AF', '#ECE5CE', '#C5E0DC' ],
    [ '#f2d8c9', '#260b01', '#73564c', '#bf9484', '#d9beb4' ],
    [ '#f2dcc9', '#593018', '#734c36', '#d9b6a3', '#0d0d0d' ],
    [ '#8c5626', '#bf6836', '#592614', '#bf5a36', '#a64029' ],
    [ '#655643', '#80BCA3', '#F6F7BD', '#E6AC27', '#BF4D28' ],
    [ '#ffa822', '#134e6f', '#ff6150', '#1ac0c6', '#dee0e6' ],
    [ '#E8DDCB', '#CDB380', '#036564', '#033649', '#031634' ],
    [ '#f2c063', '#a68446', '#d9a25f', '#8c6a3f', '#59452c' ],
    [ '#d99e30', '#a67a44', '#732002', '#d94625', '#400101' ],
    [ '#f7a400', '#3a9efd', '#3e4491', '#292a73', '#1a1b4b' ],
    [ '#D9CEB2', '#948C75', '#D5DED9', '#7A6A53', '#99B2B7' ],
    [ '#403f3c', '#f2bb77', '#59372a', '#a68376', '#bfbfbf' ],
    [ '#f2bb13', '#f28c0f', '#d9a577', '#a61b0f', '#f2f2f2' ],
    [ '#ECD078', '#D95B43', '#C02942', '#542437', '#53777A' ],
    [ '#bfa004', '#bf7e04', '#bf4904', '#bf1304', '#0d0d0d' ],
    [ '#f2cb05', '#f2b705', '#262523', '#d97904', '#d92818' ],
    [ '#888c6c', '#a67244', '#402110', '#8c2016', '#590a0a' ],
    [ '#EFFFCD', '#DCE9BE', '#555152', '#2E2633', '#99173C' ],
    [ '#264022', '#698c46', '#bf9278', '#d9ccc5', '#735e5a' ],
    [ '#99B898', '#FECEA8', '#FF847C', '#E84A5F', '#2A363B' ],
    [ '#58735c', '#f2dc9b', '#bf8a6b', '#260101', '#0d0d0d' ],
    [ '#32a65a', '#84d9a2', '#014005', '#f2f2f2', '#0d0d0d' ],
    [ '#12492f', '#0a2f35', '#f56038', '#f7a325', '#ffca7a' ],
    [ '#e0f0ea', '#95adbe', '#574f7d', '#503a65', '#3c2a4d' ],
    [ '#204037', '#558c3b', '#9cd95f', '#bfa78a', '#f2541b' ],
    [ '#3FB8AF', '#7FC7AF', '#DAD8A7', '#FF9E9D', '#FF3D7F' ],
    [ '#d7d9d9', '#a69d8d', '#d9a282', '#401f14', '#734136' ],
    [ '#343838', '#005F6B', '#008C9E', '#00B4CC', '#00DFFC' ],
    [ '#00A0B0', '#6A4A3C', '#CC333F', '#EB6841', '#EDC951' ],
    [ '#323e40', '#f2ab27', '#d97d0d', '#732002', '#d94d1a' ],
    [ '#00A8C6', '#40C0CB', '#F9F2E7', '#AEE239', '#8FBE00' ],
    [ '#69D2E7', '#A7DBD8', '#E0E4CC', '#F38630', '#FA6900' ],
    [ '#03738c', '#037f8c', '#04d9d9', '#f28972', '#f20505' ],
    [ '#7eb3bf', '#8c8630', '#f2f0ce', '#f2bb9b', '#d9765f' ],
    [ '#779da6', '#034001', '#f2df7e', '#f2efe9', '#f25244' ],
    [ '#a2cdf2', '#0367a6', '#49b1f2', '#027373', '#7f8c1c' ],
    [ '#1f4c73', '#387ca6', '#96d2d9', '#f2e8c9', '#402f11' ],
    [ '#0476d9', '#05aff2', '#a4d932', '#f2be22', '#f2cc85' ],
    [ '#0468bf', '#05aff2', '#f2b705', '#f28705', '#bf3604' ],
    [ '#034c8c', '#69a7bf', '#f2e205', '#f2cb05', '#f2d49b' ],
    [ '#6d8ba6', '#bfcfd9', '#bfb84e', '#8c6e37', '#bf9e75' ],
    [ '#89b3d9', '#f2e6d8', '#d9985f', '#59220e', '#a64521' ],
    [ '#556270', '#4ECDC4', '#C7F464', '#FF6B6B', '#C44D58' ],
    [ '#072448', '#54d2d2', '#ffcb00', '#f8aa4b', '#ff6150' ],
    [ '#0f5cbf', '#072b59', '#0f6dbf', '#042940', '#72dbf2' ],
    [ '#034aa6', '#03588c', '#aab7bf', '#56a662', '#f26e22' ],
    [ '#314259', '#d9843b', '#73310a', '#a64914', '#0d0d0d' ],
    [ '#021f59', '#2c4001', '#f25c05', '#bf7665', '#a60303' ],
    [ '#c2d2f2', '#5176a6', '#70731f', '#a67d4b', '#a64b29' ],
    [ '#0442bf', '#5cacf2', '#f2b705', '#f29f05', '#f2b8a2' ],
    [ '#b3c3f2', '#8fa690', '#73450d', '#bfa78a', '#403d3c' ],
    [ '#454d66', '#309975', '#58b368', '#dad873', '#efeeb4' ],
    [ '#1f306e', '#553772', '#8f3b76', '#c7417b', '#f5487f' ],
    [ '#122c91', '#2a6fdb', '#48d6d2', '#81e9e6', '#fefcbf' ],
    [ '#222e73', '#032ca6', '#85bff2', '#f2c84b', '#f29f05' ],
    [ '#565bbf', '#071526', '#d6d98b', '#d9984a', '#d99873' ],
    [ '#272643', '#ffffff', '#e3f6f5', '#bae8e8', '#2c698d' ],
    [ '#343090', '#5f59f7', '#6592fd', '#44c2fd', '#8c61ff' ],
    [ '#413E4A', '#73626E', '#B38184', '#F0B49E', '#F7E4BE' ],
    [ '#492b7c', '#301551', '#ed8a0a', '#f6d912', '#fff29c' ],
    [ '#27104e', '#64379f', '#9854cb', '#ddacf5', '#75e8e7' ],
    [ '#663f8c', '#038c4c', '#f29727', '#f25f29', '#bf2626' ],
    [ '#8a00d4', '#d527b7', '#f782c2', '#f9c46b', '#e3e3e3' ],
    [ '#613873', '#5d3b8c', '#382859', '#bf5b45', '#d9a19c' ],
    [ '#3f0259', '#f2e205', '#f2b705', '#f2ebdc', '#d95e32' ],
    [ '#361d32', '#543c52', '#f55951', '#edd2cb', '#f1e8e6' ],
    [ '#490A3D', '#BD1550', '#E97F02', '#F8CA00', '#8A9B0F' ],
    [ '#a6032f', '#022873', '#035aa6', '#04b2d9', '#05dbf2' ],
    [ '#E94E77', '#D68189', '#C6A49A', '#C6E5D9', '#F4EAD5' ],
    [ '#bf4e63', '#f2f2f2', '#d9ae5f', '#bf7d65', '#d9a38f' ],
    [ '#730217', '#090b0d', '#f2cb05', '#594302', '#d94f30' ],
    [ '#a66a75', '#580259', '#f05cf2', '#f2e205', '#f2d43d' ],
    [ '#d94a64', '#d99379', '#f2cbbd', '#a6523f', '#f2f2f2' ],
    [ '#FE4365', '#FC9D9A', '#F9CDAD', '#C8C8A9', '#83AF9B' ],
    [ '#d90d32', '#d3d9a7', '#f25116', '#bf3111', '#f2f2f2' ],
    [ '#f26d85', '#bf214b', '#c1d0d9', '#0e6973', '#0e7373' ],
    [ '#731a22', '#a63f48', '#bdd959', '#bfa095', '#8c5042' ],
    [ '#bf656d', '#732944', '#a67665', '#d9a796', '#8c5042' ],
    [ '#d94e5a', '#012e40', '#add1d9', '#8c0303', '#a64b4b' ],
    [ '#f21326', '#60bfbf', '#98d979', '#d99e30', '#f29999' ],
    [ '#bf2633', '#f2b90f', '#f2b33d', '#a67a29', '#a66249' ],
    [ '#f21b2d', '#f23d5e', '#777cd9', '#525559', '#e9eff2' ],
    [ '#8c0712', '#bf8a49', '#bfbcba', '#73574d', '#400303' ],
    [ '#FF4E50', '#FC913A', '#F9D423', '#EDE574', '#E1F5C4' ]
]

export const allPalettesWithBlack = [
    [ '#000', '#262626', '#595959', '#8c8c8c', '#a6a6a6', '#d9d9d9' ],
    [ '#000', '#594F4F', '#547980', '#45ADA8', '#9DE0AD', '#E5FCC2' ],
    [ '#000', '#594F4F', '#547980', '#45ADA8', '#9DE0AD', '#E5FCC2' ],
    [ '#000', '#e74645', '#fb7756', '#1ac0c6', '#facd60', '#fdfa66' ],
    [ '#000', '#264e70', '#679186', '#f9b4ab', '#bbd4ce', '#fdebd3' ],
    [ '#000', '#590a0a', '#a63429', '#d96262', '#bf7c63', '#d9a796' ],
    [ '#000', '#774F38', '#E08E79', '#F1D4AF', '#C5E0DC', '#ECE5CE' ],
    [ '#000', '#592614', '#a64029', '#8c5626', '#bf5a36', '#bf6836' ],
    [ '#000', '#655643', '#BF4D28', '#80BCA3', '#E6AC27', '#F6F7BD' ],
    [ '#000', '#134e6f', '#ff6150', '#1ac0c6', '#ffa822', '#dee0e6' ],
    [ '#000', '#031634', '#033649', '#036564', '#CDB380', '#E8DDCB' ],
    [ '#000', '#59452c', '#8c6a3f', '#a68446', '#d9a25f', '#f2c063' ],
    [ '#000', '#400101', '#732002', '#d94625', '#a67a44', '#d99e30' ],
    [ '#000', '#1a1b4b', '#292a73', '#3e4491', '#3a9efd', '#f7a400' ],
    [ '#000', '#7A6A53', '#948C75', '#99B2B7', '#D9CEB2', '#D5DED9' ],
    [ '#000', '#403f3c', '#59372a', '#a68376', '#bfbfbf', '#f2bb77' ],
    [ '#000', '#a61b0f', '#f28c0f', '#d9a577', '#f2bb13', '#f2f2f2' ],
    [ '#000', '#542437', '#C02942', '#53777A', '#D95B43', '#ECD078' ],
    [ '#000', '#262523', '#d92818', '#d97904', '#f2b705', '#f2cb05' ],
    [ '#000', '#402110', '#590a0a', '#8c2016', '#a67244', '#888c6c' ],
    [ '#000', '#2E2633', '#555152', '#99173C', '#DCE9BE', '#EFFFCD' ],
    [ '#000', '#264022', '#735e5a', '#698c46', '#bf9278', '#d9ccc5' ],
    [ '#000', '#2A363B', '#E84A5F', '#FF847C', '#99B898', '#FECEA8' ],
    [ '#000', '#0a2f35', '#12492f', '#f56038', '#f7a325', '#ffca7a' ],
    [ '#000', '#3c2a4d', '#503a65', '#574f7d', '#95adbe', '#e0f0ea' ],
    [ '#000', '#204037', '#558c3b', '#f2541b', '#bfa78a', '#9cd95f' ],
    [ '#000', '#FF3D7F', '#3FB8AF', '#FF9E9D', '#7FC7AF', '#DAD8A7' ],
    [ '#000', '#401f14', '#734136', '#a69d8d', '#d9a282', '#d7d9d9' ],
    [ '#000', '#343838', '#005F6B', '#008C9E', '#00B4CC', '#00DFFC' ],
    [ '#000', '#6A4A3C', '#CC333F', '#EB6841', '#00A0B0', '#EDC951' ],
    [ '#000', '#323e40', '#732002', '#d94d1a', '#d97d0d', '#f2ab27' ],
    [ '#000', '#00A8C6', '#8FBE00', '#40C0CB', '#AEE239', '#F9F2E7' ],
    [ '#000', '#FA6900', '#F38630', '#69D2E7', '#A7DBD8', '#E0E4CC' ],
    [ '#000', '#03738c', '#037f8c', '#f20505', '#f28972', '#04d9d9' ],
    [ '#000', '#8c8630', '#d9765f', '#7eb3bf', '#f2bb9b', '#f2f0ce' ],
    [ '#000', '#034001', '#f25244', '#779da6', '#f2df7e', '#f2efe9' ],
    [ '#000', '#0367a6', '#027373', '#7f8c1c', '#49b1f2', '#a2cdf2' ],
    [ '#000', '#402f11', '#1f4c73', '#387ca6', '#96d2d9', '#f2e8c9' ],
    [ '#000', '#0476d9', '#05aff2', '#f2be22', '#a4d932', '#f2cc85' ],
    [ '#000', '#0468bf', '#bf3604', '#f28705', '#05aff2', '#f2b705' ],
    [ '#000', '#034c8c', '#69a7bf', '#f2cb05', '#f2d49b', '#f2e205' ],
    [ '#000', '#8c6e37', '#6d8ba6', '#bf9e75', '#bfb84e', '#bfcfd9' ],
    [ '#000', '#59220e', '#a64521', '#d9985f', '#89b3d9', '#f2e6d8' ],
    [ '#000', '#556270', '#C44D58', '#FF6B6B', '#4ECDC4', '#C7F464' ],
    [ '#000', '#072448', '#ff6150', '#f8aa4b', '#54d2d2', '#ffcb00' ],
    [ '#000', '#042940', '#072b59', '#0f5cbf', '#0f6dbf', '#72dbf2' ],
    [ '#000', '#034aa6', '#03588c', '#56a662', '#f26e22', '#aab7bf' ],
    [ '#000', '#021f59', '#2c4001', '#a60303', '#bf7665', '#f25c05' ],
    [ '#000', '#a64b29', '#70731f', '#5176a6', '#a67d4b', '#c2d2f2' ],
    [ '#000', '#0442bf', '#5cacf2', '#f29f05', '#f2b705', '#f2b8a2' ],
    [ '#000', '#403d3c', '#73450d', '#8fa690', '#bfa78a', '#b3c3f2' ],
    [ '#000', '#454d66', '#309975', '#58b368', '#dad873', '#efeeb4' ],
    [ '#000', '#1f306e', '#553772', '#8f3b76', '#c7417b', '#f5487f' ],
    [ '#000', '#122c91', '#2a6fdb', '#48d6d2', '#81e9e6', '#fefcbf' ],
    [ '#000', '#222e73', '#032ca6', '#f29f05', '#85bff2', '#f2c84b' ],
    [ '#000', '#272643', '#2c698d', '#bae8e8', '#e3f6f5', '#ffffff' ],
    [ '#000', '#343090', '#5f59f7', '#8c61ff', '#6592fd', '#44c2fd' ],
    [ '#000', '#413E4A', '#73626E', '#B38184', '#F0B49E', '#F7E4BE' ],
    [ '#000', '#301551', '#492b7c', '#ed8a0a', '#f6d912', '#fff29c' ],
    [ '#000', '#27104e', '#64379f', '#9854cb', '#ddacf5', '#75e8e7' ],
    [ '#000', '#663f8c', '#bf2626', '#038c4c', '#f25f29', '#f29727' ],
    [ '#000', '#8a00d4', '#d527b7', '#f782c2', '#f9c46b', '#e3e3e3' ],
    [ '#000', '#382859', '#613873', '#5d3b8c', '#bf5b45', '#d9a19c' ],
    [ '#000', '#3f0259', '#d95e32', '#f2b705', '#f2e205', '#f2ebdc' ],
    [ '#000', '#361d32', '#543c52', '#f55951', '#edd2cb', '#f1e8e6' ],
    [ '#000', '#490A3D', '#BD1550', '#8A9B0F', '#E97F02', '#F8CA00' ],
    [ '#000', '#022873', '#a6032f', '#035aa6', '#04b2d9', '#05dbf2' ],
    [ '#000', '#E94E77', '#D68189', '#C6A49A', '#C6E5D9', '#F4EAD5' ],
    [ '#000', '#bf4e63', '#bf7d65', '#d9a38f', '#d9ae5f', '#f2f2f2' ],
    [ '#000', '#580259', '#a66a75', '#f05cf2', '#f2d43d', '#f2e205' ],
    [ '#000', '#a6523f', '#d94a64', '#d99379', '#f2cbbd', '#f2f2f2' ],
    [ '#000', '#FE4365', '#83AF9B', '#FC9D9A', '#C8C8A9', '#F9CDAD' ],
    [ '#000', '#bf3111', '#d90d32', '#f25116', '#d3d9a7', '#f2f2f2' ],
    [ '#000', '#0e6973', '#bf214b', '#0e7373', '#f26d85', '#c1d0d9' ],
    [ '#000', '#731a22', '#8c5042', '#a63f48', '#bfa095', '#bdd959' ],
    [ '#000', '#732944', '#8c5042', '#bf656d', '#a67665', '#d9a796' ],
    [ '#000', '#012e40', '#8c0303', '#a64b4b', '#d94e5a', '#add1d9' ],
    [ '#000', '#f21326', '#d99e30', '#60bfbf', '#f29999', '#98d979' ],
    [ '#000', '#bf2633', '#a66249', '#a67a29', '#f2b33d', '#f2b90f' ],
    [ '#000', '#525559', '#f21b2d', '#777cd9', '#f23d5e', '#e9eff2' ],
    [ '#000', '#400303', '#8c0712', '#73574d', '#bf8a49', '#bfbcba' ],
    [ '#000', '#FF4E50', '#FC913A', '#F9D423', '#EDE574', '#E1F5C4' ]
]

// export const allPalettesWithBlack = allPalettes.map(palette => {
//
//     const minLuminance = 1600
//     const luminances = {}
//
//     palette.forEach(col => luminances[col] = getLuminance(Color.from(col)));
//     palette.sort(
//         (a,b) => {
//             return luminances[a] - luminances[b]
//         }
//     )
//
//     if (luminances[palette[0]] > minLuminance)
//     {
//         //console.log("Add black")
//         palette = palette.slice()
//         palette.unshift("#000")
//         luminances["#000"]  = 0
//     }
//
//     return palette
// })

function arrayEq(a,b)
{
    const len = a.length;
    if (len !== b.length)
    {
        return false;
    }

    for (let i=0; i < len; i++)
    {
        if (a[i] !== b[i])
        {
            return false;
        }
    }

    return true;
}


export default function randomPalette(rnd = Math.random(), filter) {
    const all = filter ? allPalettes.filter(filter) : allPalettes
    return all[0 | rnd * all.length]
}

export function randomPaletteWithBlack(rnd = Math.random(), filter, minLuminance = 1600) {
    let palette = randomPalette(rnd, filter);

    let min = Infinity
    let darkest


    const luminances = {}

    palette.forEach(col => luminances[col] = getLuminance(Color.from(col)));
    palette.sort(
        (a,b) => {
            return luminances[a] - luminances[b]
        }
    )


    if (luminances[palette[0]] > minLuminance)
    {
        //console.log("Add black")
        palette = palette.slice()
        palette.unshift("#000")
        luminances["#000"]  = 0
    }

    // for (let i = 0; i < palette.length; i++)
    // {
    //     const col = palette[i];
    //     console.log(col, ": ", luminances[col])
    // }

    return palette

}
